module.exports = __webpack_public_path__ + "static/insolvency-services-c8818a2a790e321abda81b3cc2ccc9cd.jpg";